"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Quali sono i tempi medi per l'ottenimento di un visto?",
  answer: "Le tempistiche variano significativamente in base alla tipologia di visto e al paese di destinazione. Generalmente, le pratiche per visti turistici o d'affari richiedono dai 5 ai 15 giorni lavorativi, mentre i visti per studio o lavoro possono richiedere diverse settimane."
}, {
  question: "Fornite assistenza per la legalizzazione dei documenti?",
  answer: "Certamente. Gestiamo l'intero processo di legalizzazione e apostille presso Prefetture, Procure e Consolati, assicurando che i vostri documenti siano validi a livello internazionale per scopi commerciali o personali."
}, {
  question: "Come posso monitorare lo stato della mia pratica?",
  answer: "Ogni cliente riceve un accesso dedicato al nostro portale dove è possibile visualizzare in tempo reale l'avanzamento della pratica, caricare documenti mancanti e comunicare direttamente con il consulente assegnato."
}, {
  question: "Offrite consulenza per l'immigrazione aziendale?",
  answer: "Sì, supportiamo le aziende nel processo di distacco internazionale dei dipendenti, gestione dei Nulla Osta e permessi di soggiorno, garantendo la piena conformità alle normative vigenti in materia di immigrazione."
}, {
  question: "Quali sono le modalità di pagamento accettate?",
  answer: "Accettiamo pagamenti tramite bonifico bancario, carte di credito dei principali circuiti e sistemi di pagamento digitale. Per le aziende con volumi elevati, offriamo piani di fatturazione mensile personalizzati."
}];
export default function DuvidasFrequentes() {
  return <section data-section-id="224976" id="domande-frequenti" className="bg-background text-foreground py-24 px-4 md:px-8">
      <div className="mx-auto max-w-[800px]">
        <div className="mb-12 text-center">
          <span className="text-secondary font-mono text-sm font-bold uppercase tracking-widest mb-2 block">
            COMMON INQUIRIES
          </span>
          <h2 className="text-foreground font-default text-3xl md:text-4xl font-bold mb-4">
            Domande Frequenti
          </h2>
          <p className="text-muted-foreground font-sans text-base">
            Trovate risposte rapide ai dubbi più comuni sui nostri servizi di visti e immigrazione.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full border border-border rounded-none bg-card overflow-hidden shadow-lg backdrop-blur-sm">
          {faqs.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border px-0">
              <AccordionTrigger className="group [&>svg:last-child]:hidden hover:no-underline px-6 py-6">
                <span className="text-lg font-bold text-foreground font-default text-left">
                  {item.question}
                </span>
                <Plus className="size-6 shrink-0 text-secondary transition-transform duration-300 group-data-[state=open]:rotate-45" />
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-sans text-base px-6 pb-6 pt-0 leading-relaxed font-normal">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}